module.exports = __webpack_public_path__ + "svg_80x80/laravel.489d55.svg";